export const TRIGGER_NAME_MAP: any = {
  team_join: "New user joins discord",
  button_click: "Button click",
  role_change: "User's role was changed",
  command: "Slash command",
};
